const getters = {
  getWhiteLabelStatus: (state) => state.whiteLabelStatus,
  getWhiteLabelLogo: (state) => state.whiteLabeLogo,
  getWhiteLabelUrl: (state) => state.whiteLabelUrl,
  getWhiteLabelTitle: (state) => state.whiteLabelTitle,
  getSiteUrl: (state) => state.whiteLabelSiteUrl,
}
export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/white-label/getters.js